module.exports = prefixSize;
var sizeChunks = require('./size-chunks');
function prefixSize(events, type) {
  var tail = events[events.length - 1];
  if (!tail || tail[1].type !== type) return 0;
  return sizeChunks(tail[2].sliceStream(tail[1]));
}